import {TitleProps} from 'antd/lib/typography/Title'
import React, {FC, useMemo} from 'react'
import {JHTML} from '../JHTML'
import {CMSPage} from '../models'
import './JHeaderTitle.scss'

export interface JHeaderTitleProps extends Partial<Pick<CMSPage, 'title' | 'subTitle' | 'text'>> {
    align?: 'left' | 'center',
    headingLevel?: TitleProps['level'],
    additionalClasses?: string;
}

export const JHeaderTitle: FC<JHeaderTitleProps> = props => {
    const align = useMemo(() => props.align || 'left', [props.align])

    return (
        <div className={`jheadertitle jheadertitle-align-${align}`}>
            {
                props.title && (
                    <JHTML.Title level={props.headingLevel || 1} html={props.title}
                                 additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.subTitle && (
                    <JHTML.SubTitle html={props.subTitle} additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.text && (
                    <JHTML.Text html={props.text} additionalClasses={props.additionalClasses}/>
                )
            }
        </div>
    )
}
export const JSectionHeaderTitle: FC<JHeaderTitleProps> = props => {
    const align = useMemo(() => props.align || 'left', [props.align])
    return (
        <div className={`jheadertitle jheadertitle-section jheadertitle-align-${align}`}>
            {
                props.title && (
                    <JHTML.SectionTitle level={props.headingLevel} html={props.title}
                                        additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.subTitle && (
                    <JHTML.SubTitle html={props.subTitle} additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.text && (
                    <JHTML.Text html={props.text} additionalClasses={props.additionalClasses}/>
                )
            }
        </div>
    )
}
export const JPageHeaderTitle: FC<JHeaderTitleProps> = props => {
    const align = useMemo(() => props.align || 'left', [props.align])
    return (
        <div className={`jheadertitle jheadertitle-page jheadertitle-align-${align}`}>
            {
                props.title && (
                    <JHTML.PageTitle html={props.title} additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.subTitle && (
                    <JHTML.SubTitle html={props.subTitle} additionalClasses={props.additionalClasses}/>
                )
            }
            {
                props.text && (
                    <JHTML.Text html={props.text} additionalClasses={props.additionalClasses}/>
                )
            }
        </div>
    )
}
